"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseEncodings = parseEncodings;
exports.elOnPlay = elOnPlay;
function parseEncodings(format) {
    if (format.substitute != null) {
        // that comes from manifest
        // if it has substitute then the stream is blurred
        // so we just won't provide any real encodings
        return [format.substitute];
    }
    else {
        return format.encodings;
    }
}
function elOnPlay(sf, oldState) {
}
//# sourceMappingURL=helpers.js.map